import * as React from 'react';

import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';

interface InsightsGenerationBlockerDialogProps {
  open: boolean;
  onClose: () => void;
}

export function InsightsGenerationBlockerDialog({ open, onClose }: InsightsGenerationBlockerDialogProps) {
  return (
    <DialogConfirmation
      id="insights-generation-blocker-dialog"
      open={open}
      onClose={onClose}
      title={translate('No Insights Found')}
      actions={[
        <UIButton key="ok" onClick={onClose}>
          {translate('OK')}
        </UIButton>,
      ]}
    >
      {translate('AI Insights analyzes responses to see where participants can improve.')}
    </DialogConfirmation>
  );
}
